import { truncateString } from 'lib/utils/string-utils';
import sanitizeHtml from 'sanitize-html';

// Sanitize most seo data text fields, truncate some of them
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function sanitizeSeoData(dataObj: any, filterType?: string) {
  // Data items that should be truncated, mainly metadata descriptions. Add more here if needed
  const stringsToTruncate = new Set(['metaDescription', 'ogDescription', 'twitterDescription']);

  const textFilter = function (text: string) {
    // Restore ampersands that get converted by default
    return text.replace(/&amp;/g, '&');
  };

  let sanitizeConfig;
  switch (filterType) {
    case 'richtext':
      sanitizeConfig = {
        allowedTags: [
          'h1',
          'h2',
          'h3',
          'h4',
          'h5',
          'h6',
          'br',
          'ul',
          'ol',
          'li',
          'a',
          'p',
          'div',
          'b',
          'i',
          'strong',
          'em',
        ],
        allowedAttributes: {
          a: ['href', 'name', 'target', 'rel'],
        },
        textFilter: textFilter,
      };
      break;
    default:
      sanitizeConfig = {
        allowedTags: [],
        allowedAttributes: {},
        textFilter: textFilter,
      };
  }

  // Recursively loop through data and sanitize all text fields
  for (const [key, value] of Object.entries(dataObj)) {
    // Check if the current value is still an object, if so, run it again
    if (typeof value === 'object' && value !== null) {
      sanitizeSeoData(value, filterType);
      // Run on all strings except for urls
    } else if (typeof value === 'string' && !key.toLowerCase().includes('url')) {
      // Insert space where adjacent tags exist, remove whitespace, and conditionally truncate
      const preText = value.replace(/>(\n)+</g, '> <').trim();
      const textToSanitize = stringsToTruncate.has(key) ? truncateString(preText, 160) : preText;
      // Sanitize and mutate it
      const sanitizedText = sanitizeHtml(textToSanitize, sanitizeConfig);
      dataObj[key] = sanitizedText;
    }
  }

  return dataObj;
}
